// What name to show for a transaction: the AI-cleaned display_name when the
// backend was confident enough to set it, otherwise the raw bank string.
export function displayName(txn) {
  return txn.display_name || txn.description_raw
}

// Google-lookup link for "what was this place?" moments. A plain hyperlink —
// the search runs in the user's own browser, so clicking costs nothing.
// Query quality is the whole game: for decoded rows we search the clean name
// PLUS the raw string ("FreshChoice FRESHCHOICE TINWALD ASHBURTON") — the raw
// string carries the town, so Google lands on the actual shop listing instead
// of the chain's homepage. Undecoded rows search the raw string alone.
export function googleLookupUrl(txn) {
  const query = txn.display_name
    ? `${txn.display_name} ${txn.description_raw}`
    : txn.description_raw
  return `https://www.google.com/search?q=${encodeURIComponent(query)}`
}

// Should this transaction be surfaced in the "needs a quick look" nudge?
export function needsReview(txn) {
  // Excluded rows are out of the settlement on purpose — nothing to review.
  if (txn.status === 'excluded') return false
  // Ambiguous participants block settlement math REGARDLESS of status:
  // the backend skips type-"ask" rows even when the row is "confirmed"
  // (manual expenses are always created confirmed). If we gated this on
  // status, the Settle page would say "1 needs review" while this screen
  // highlighted nothing — which is exactly the bug a user reported.
  const ptype = txn.participants_json?.type
  const ambiguousParticipants =
    ptype === 'ask' ||
    (ptype === 'single' && !txn.participants_json?.member_ids?.length)
  // Did the user explicitly assign people at some point? The audit trail
  // (overrides_json.participants) records every manual participant edit.
  // Assigning people IS a review — the backend now promotes these rows to
  // "confirmed" on edit, but rows assigned before that fix are still stored
  // as "unreviewed", so we honor the audit trail here for historical data.
  // Only counts when the CURRENT assignment is concrete (not back-to-"ask").
  const userAssigned = !!txn.overrides_json?.participants && !ambiguousParticipants
  // An undecoded merchant name is only worth a nudge while the row is
  // still unreviewed — once confirmed (or hand-assigned), the user has
  // seen and accepted it.
  const undecodedName = txn.status === 'unreviewed' && !txn.display_name && !userAssigned
  return ambiguousParticipants || undecodedName
}
